import Text from '@eversports/react-components/primitives/Text'
import { assertNever } from '@eversports/utility-types'
import React from 'react'

import { Localized } from '../../localization/react'
import { PaymentOption } from '../../typings/Payment'

interface Props {
  paymentOption: PaymentOption
}

const PaymentMethodExpansionPanelHeaderText: React.FC<React.PropsWithChildren<Props>> = ({ paymentOption }) => {
  switch (paymentOption) {
    case 'pay-with-ideal':
      return (
        <Localized
          id="payment-pay-with-ideal-heading"
          params={{
            chargeInfo: (
              <Text is="span" color="subtleText">
                <Localized id="payment-charge-info" />
              </Text>
            ),
          }}
        />
      )
    case 'pay-with-sepa-ideal':
      return (
        <Localized
          id="payment-pay-with-sepa-ideal-heading"
          params={{
            chargeInfo: (
              <Text is="span" color="subtleText">
                <Localized id="payment-charge-info" />
              </Text>
            ),
          }}
        />
      )
    case 'pay-with-credit-card':
      return (
        <Localized
          id="payment-pay-with-credit-card-heading"
          params={{
            chargeInfo: (
              <Text is="span" color="subtleText">
                <Localized id="payment-charge-info" />
              </Text>
            ),
          }}
        />
      )
    case 'additional-payment-methods':
      return (
        <Localized
          id="payment-additional-payment-methods-heading"
          params={{
            chargeInfo: (
              <Text is="span" color="subtleText">
                <Localized id="payment-charge-info" />
              </Text>
            ),
          }}
        />
      )
    default:
      return assertNever(paymentOption)
  }
}

export default PaymentMethodExpansionPanelHeaderText
